
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable object-shorthand */
/* eslint-disable consistent-return */
import axiosInstance from 'src/api/axiosInstance';
import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Typography, Stack, Button, Dialog, DialogActions,
  Fade, Chip, TextField, IconButton,
  DialogContent, CircularProgress, Tooltip,
  Checkbox,
  LinearProgress,
} from '@mui/material';
import Switch from '@mui/material/Switch';
import {
  Check, Close, Add, Remove, ArrowForward,
  PaymentsOutlined, PersonAddOutlined,
  PersonRemoveOutlined, InfoOutlined, Send,
} from '@mui/icons-material';
import AccountBalanceWalletOutlined from '@mui/icons-material/AccountBalanceWalletOutlined';
import AutorenewRounded from '@mui/icons-material/AutorenewRounded';
import CloseRounded from '@mui/icons-material/CloseRounded';
import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import { alpha } from '@mui/material/styles';
import { PaymentSuccessPopup } from './Paymentsuccesspopup';
import { fetchBillingPreview } from './pricingService';

// ─── UNCHANGED: ScrollAnimation ────────────────────────────────────────────
export const ScrollAnimation = ({ children, sx, delay, ...props }) => (
  <Box
    sx={{
      ...sx,
      animation: 'fadeInUp 0.6s ease-out forwards',
      opacity: 0,
      transform: 'translateY(20px)',
      animationDelay: `${delay || 0}ms`,
      '@keyframes fadeInUp': { to: { opacity: 1, transform: 'translateY(0)' } },
    }}
    {...props}
  >
    {children}
  </Box>
);

// ─── PaymentModeCard (unchanged, used inside Billing tab) ─────────────────
function PaymentModeCard({ mode, selected, onClick, billingCycle, disabled = false }) {
  const isAuto = mode === 'AUTO_DEBIT';
  return (
    <Box
      onClick={disabled ? undefined : onClick}
      sx={{
        flex: 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.45 : 1,
        borderRadius: '10px',
        border: selected ? '1.5px solid' : '0.5px solid',
        borderColor: selected ? 'primary.main' : 'divider',
        bgcolor: selected ? 'action.selected' : 'background.paper',
        p: 1.25,
        position: 'relative',
        transition: 'all 0.15s ease',
        '&:hover': !disabled ? {
          borderColor: selected ? 'primary.main' : 'text.disabled',
        } : {},
      }}
    >
      {isAuto && (
        <Chip
          label="Auto Renew"
          size="small"
          sx={{
            position: 'absolute', top: -8, right: 8, height: 16,
            fontSize: '0.58rem', fontWeight: 700,
            bgcolor: 'primary.main', color: '#fff',
            '& .MuiChip-label': { px: 0.7 },
          }}
        />
      )}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={0.5}>
        <Box
          sx={{
            width: 24, height: 24, borderRadius: '7px',
            bgcolor: selected ? 'primary.lighter' : 'action.hover',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {isAuto
            ? <AutorenewRounded sx={{ fontSize: 13, color: selected ? 'primary.main' : 'text.disabled' }} />
            : <PaymentsOutlined sx={{ fontSize: 13, color: selected ? 'primary.main' : 'text.disabled' }} />}
        </Box>
        <Box
          sx={{
            width: 15, height: 15, borderRadius: '50%',
            border: '1.5px solid',
            borderColor: selected ? 'primary.main' : 'text.disabled',
            bgcolor: selected ? 'primary.main' : 'transparent',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            mt: 0.2,
          }}
        >
          {selected && <Check sx={{ fontSize: 8, color: '#fff' }} />}
        </Box>
      </Stack>
      <Typography sx={{ fontWeight: 600, fontSize: '0.74rem', color: selected ? 'primary.main' : 'text.primary', lineHeight: 1.2 }}>
        {isAuto ? 'Auto-Debit' : 'Manual Invoice'}
      </Typography>
      <Typography sx={{ fontSize: '0.64rem', color: 'text.secondary', lineHeight: 1.3, mt: 0.3 }}>
        {isAuto
          ? billingCycle === 'annual' ? 'Charged annually automatically' : 'Charged monthly automatically'
          : billingCycle === 'annual' ? 'Billed annually via invoice' : 'Billed monthly via invoice'}
      </Typography>
    </Box>
  );
}

// ─── SummaryRow (unchanged) ────────────────────────────────────────────────
function SummaryRow({ label, value, valueColor, isTotal }) {
  if (value === null || value === undefined) return null;
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 0.4 }}>
      <Typography sx={{ fontSize: isTotal ? '0.78rem' : '0.72rem', color: isTotal ? 'text.primary' : 'text.secondary', fontWeight: isTotal ? 600 : 400 }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: isTotal ? '0.78rem' : '0.72rem', fontWeight: isTotal ? 700 : 500, color: valueColor || (isTotal ? 'text.primary' : 'text.primary'), letterSpacing: '-0.01em', whiteSpace: 'nowrap' }}>
        {value}
      </Typography>
    </Stack>
  );
}

// ─── SectionLabel (unchanged) ──────────────────────────────────────────────
function SectionLabel({ children }) {
  return (
    <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, color: 'text.disabled', letterSpacing: '0.08em', textTransform: 'uppercase', mb: 0.6 }}>
      {children}
    </Typography>
  );
}

// ─── SeatStat (unchanged) ─────────────────────────────────────────────────
function SeatStat({ value, label, color }) {
  return (
    <Box sx={{ flex: 1, bgcolor: 'action.hover', borderRadius: '10px', p: 1, textAlign: 'center' }}>
      <Typography sx={{ fontSize: '1.15rem', fontWeight: 700, color: color || 'text.primary', lineHeight: 1.1 }}>
        {value}
      </Typography>
      <Typography sx={{ fontSize: '0.62rem', color: 'text.secondary', mt: 0.35, lineHeight: 1.25 }}>
        {label}
      </Typography>
    </Box>
  );
}

// ─── CounterControl (unchanged) ───────────────────────────────────────────
function CounterControl({ value, onChange, max, colorScheme = 'blue' }) {
  const isRed = colorScheme === 'red';
  return (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ flexShrink: 0 }}>
      <IconButton
        onClick={() => onChange(Math.max(0, value - 1))}
        size="small"
        sx={{
          width: 28, height: 28, borderRadius: '8px',
          border: '0.5px solid', borderColor: 'divider',
          bgcolor: 'background.paper', color: 'error.main',
          '&:hover': { bgcolor: 'error.lighter', borderColor: 'error.light' },
        }}
      >
        <Remove sx={{ fontSize: '0.8rem' }} />
      </IconButton>
      <Box sx={{
        width: 48, height: 28, borderRadius: '8px',
        border: '0.5px solid', borderColor: 'divider',
        bgcolor: 'background.paper', display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <TextField
          type="number"
          value={value}
          onChange={(e) => {
            const v = Math.max(0, Number(e.target.value));
            onChange(max !== undefined ? Math.min(max, v) : v);
          }}
          variant="standard"
          InputProps={{ disableUnderline: true }}
          sx={{
            width: 32,
            '& input': {
              textAlign: 'center', fontSize: '0.82rem', fontWeight: 700, py: 0, px: 0,
              color: isRed ? 'error.main' : 'primary.main',
              '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': { WebkitAppearance: 'none' },
            },
          }}
        />
      </Box>
      <IconButton
        onClick={() => onChange(max !== undefined ? Math.min(max, value + 1) : value + 1)}
        size="small"
        sx={{
          width: 28, height: 28, borderRadius: '8px',
          border: '0.5px solid', borderColor: 'divider',
          bgcolor: 'background.paper', color: isRed ? 'error.main' : 'success.main',
          '&:hover': {
            bgcolor: isRed ? 'error.lighter' : 'success.lighter',
            borderColor: isRed ? 'error.light' : 'success.light',
          },
        }}
      >
        <Add sx={{ fontSize: '0.8rem' }} />
      </IconButton>
    </Stack>
  );
}

// ─── SectionCard / CardHeader (unchanged) ──────────────────────────────────
function SectionCard({ children, highlighted, highlightColor, sx }) {
  return (
    <Box sx={{
      borderRadius: '12px',
      border: highlighted ? `1.5px solid ${highlightColor}35` : '0.5px solid',
      borderColor: highlighted ? undefined : 'divider',
      bgcolor: 'background.paper',
      overflow: 'hidden',
      transition: 'border-color 0.15s, box-shadow 0.15s',
      boxShadow: highlighted ? `0 2px 12px ${highlightColor}10` : 'none',
      ...sx,
    }}>
      {children}
    </Box>
  );
}

function CardHeader({ icon, title, subtitle, action, borderless }) {
  return (
    <Stack
      direction="row" justifyContent="space-between" alignItems="center"
      sx={{
        px: 1.75, py: 1.25,
        borderBottom: borderless ? 'none' : '0.5px solid',
        borderColor: 'divider',
      }}
    >
      <Stack direction="row" spacing={1.1} alignItems="center">
        <Box sx={{
          width: 26, height: 26, borderRadius: '8px',
          bgcolor: 'action.hover', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}>
          {icon}
        </Box>
        <Box>
          <Typography sx={{ fontWeight: 600, fontSize: '0.78rem', color: 'text.primary', lineHeight: 1.2 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary', mt: 0.2 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>
      {action}
    </Stack>
  );
}

// ─── NEW: TabButton — segmented control for Plan / Seats / Billing ────────
function TabButton({ label, active, onClick, badge }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        px: 1.5, py: 0.6, borderRadius: '8px', cursor: 'pointer',
        fontSize: '0.74rem', fontWeight: 600,
        color: active ? 'primary.main' : 'text.secondary',
        bgcolor: active ? 'background.paper' : 'transparent',
        border: active ? '0.5px solid' : '0.5px solid transparent',
        borderColor: active ? 'divider' : 'transparent',
        display: 'flex', alignItems: 'center', gap: 0.5,
        transition: 'all 0.12s ease',
        '&:hover': !active ? { color: 'text.primary' } : {},
      }}
    >
      {label}
      {badge ? (
        <Box sx={{
          minWidth: 15, height: 15, borderRadius: '999px', px: 0.4,
          bgcolor: active ? 'primary.lighter' : 'action.hover',
          color: active ? 'primary.main' : 'text.secondary',
          fontSize: '0.6rem', fontWeight: 700,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          {badge}
        </Box>
      ) : null}
    </Box>
  );
}

// ─── MAIN: SelectionModal ─────────────────────────────────────────────────
// All props, state, computed values, effects, and API calls are UNCHANGED
// from the original — only the JSX layout below has been restructured into
// a fixed-height, tabbed (Plan / Seats / Billing) view with a pinned order
// summary, so the whole dialog fits in one viewport with no page scroll.
export function SelectionModal({
  open, onClose, plan, loading, onProceed,
  currency, billingCycle, currentPlanName, currentPlan, fetchCurrentPlan,
  onRenewClick,
}) {
  const [userCount, setUserCount] = useState(0);
  const [removeUsers, setRemoveUsers] = useState(0);
  const [paymentMode, setPaymentMode] = useState('MANUAL');
  const [enableUsers, setEnableUsers] = useState(false);
  const [seatAction, setSeatAction] = useState(null);
  const [useWallet, setUseWallet] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [couponCode, setCouponCode] = useState('');
  const [couponInput, setCouponInput] = useState('');
  const [billingPreview, setBillingPreview] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [paymentVerifying, setPaymentVerifying] = useState(false);
  const [verifyStep, setVerifyStep] = useState(0);
  const [upgradeConfirmOpen, setUpgradeConfirmOpen] = useState(false);
  const [removeConfirmOpen, setRemoveConfirmOpen] = useState(false);
  const loadingMessages = ['Calculating pricing…', 'Checking your plan…', 'Preparing checkout…'];
  const [messageIndex, setMessageIndex] = useState(0);
  const [finalUsers, setFinalUsers] = useState(0);
  // NEW: which tab is active — 'plan' | 'seats' | 'billing'
  const [activeTab, setActiveTab] = useState('plan');


  useEffect(() => {
    let interval;
    if (previewLoading) {
      interval = setInterval(() => setMessageIndex((p) => (p + 1) % loadingMessages.length), 1000);
    }
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const verifyMessages = [
    {
      title: "Processing Payment",
      subtitle: "We're securely processing your payment. This usually takes a few seconds.",
    },
    {
      title: "Verifying Transaction",
      subtitle: "Confirming your payment with our payment gateway.",
    },
    {
      title: "Activating Subscription",
      subtitle: "Updating your plan and enabling your new features.",
    },
  ];

  // ── ALL ORIGINAL COMPUTED VALUES (unchanged) ──────────────────────────
  const currentCode = (currentPlan?.planCode || currentPlan?.planName || '').toUpperCase();
  const selectedCode = (plan?.code || plan?.id || plan?.name || '').toUpperCase();
  const isSamePlan = (currentCode === selectedCode || currentCode.includes(selectedCode) || selectedCode.includes(currentCode)) &&
    currentPlan?.billingCycle?.toLowerCase() === billingCycle.toLowerCase();
  const isFreePlan = currentCode.includes('FREE');
  const currentPurchasedSeats = Number(currentPlan?.userCount ?? 0);
  const currentActiveUsers = Number(currentPlan?.activeUsers || 0);
  const isExpired = currentPlan?.expired === true;
  const isExpiringSoon = currentPlan?.expiringSoon === true || (currentPlan?.remainingDays > 0 && currentPlan?.remainingDays <= 7);
  const hasActivePlan = ['ACTIVE', 'PAYMENT_SUCCESS'].includes(currentPlan?.subscriptionStatus);

  useEffect(() => {
    if (open) {
      setUserCount(0); setRemoveUsers(0); setPaymentMode('MANUAL');
      setCouponCode(''); setCouponInput('');
      if (!isSamePlan) {
        setSeatAction("add");
      }
      setEnableUsers(false); setUseWallet(false);
      // default tab: same-plan holders land on Seats (that's the only actionable
      // tab for them); everyone else starts on Plan
      setActiveTab(isSamePlan ? 'seats' : 'plan');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, hasActivePlan]);

  const loadBillingPreview = useCallback(async () => {
    try {
      setPreviewLoading(true);
      let apiUserCount = 0;
      const scenario = (() => {
        if (isSamePlan) {
          if (removeUsers > 0) {
            apiUserCount = Math.max(1, currentPurchasedSeats - removeUsers);
            return 'REMOVE_USERS';
          }
          if (seatAction === 'add' && userCount > 0) {
            apiUserCount = currentPurchasedSeats + userCount;
            return 'ADD_USERS';
          }
          return 'MANAGE_SUBSCRIPTION';
        }
        if (hasActivePlan) {
          apiUserCount =
            currentPurchasedSeats + userCount;

          return 'PLAN_CHANGE';
        }
        const existingUsers = Math.max(currentPlan?.activeUsers || 0, 1);
        apiUserCount = seatAction === 'add' ? existingUsers + userCount : existingUsers;
        return 'NEW_SUBSCRIPTION';
      })();

      setFinalUsers(apiUserCount);

      const response = await fetchBillingPreview({
        scenario, planCode: plan?.name?.toUpperCase(),
        billingCycle: billingCycle?.toUpperCase(), userCount: apiUserCount,
        paymentMode: isSamePlan ? currentPlan?.paymentMode || 'MANUAL' : paymentMode,
        useWallet,
        couponCode,
      });
      setBillingPreview(response);
    } catch (e) {
      console.error('BILLING_PREVIEW_ERROR', e);
    } finally {
      setPreviewLoading(false);
    }
  }, [isSamePlan, hasActivePlan, plan, billingCycle, seatAction, userCount, removeUsers, paymentMode, useWallet, couponCode, currentPlan, currentPurchasedSeats]);

  useEffect(() => {
    if (!open || !plan) return;
    loadBillingPreview();
  }, [open, plan, loadBillingPreview]);

  if (!plan) return null;

  const actualBillingCycle = isSamePlan ? currentPlan?.billingCycle?.toLowerCase() : billingCycle;
  const isAnnual = actualBillingCycle === 'annual';
  const symbol = currency === 'INR' ? '₹' : '$';
  const walletBalance = Number(currentPlan?.walletBalance || 0);
  const includedUsers = Number(plan.includedUsers || 0);
  const addedUsers = seatAction === 'add' ? userCount : 0;
  const futureTotalUsers = isFreePlan ? currentActiveUsers + addedUsers : currentPurchasedSeats + addedUsers;
  const remainingIncludedUsers = Math.max(includedUsers - futureTotalUsers, 0);

  const preview = billingPreview || {};
  const subtotal = Number(preview.subtotalAmount || 0);
  const gstAmount = Number(preview.gstAmount || 0);
  const finalPayable = Number(preview.finalPayableAmount || 0);
  const recurringAmount = Number(preview.recurringAmount || 0);
  const walletApplied = Number(preview.walletUsed || 0);
  const walletFullyCovers = useWallet && preview.walletOnly === true;
  const displayAmount = finalPayable;
  const totalAddonUsers = Number(preview.addonUsers || 0);
  // Included seats remaining before this purchase
  const includedSeatsRemaining = Math.max(
    includedUsers - currentPurchasedSeats,
    0
  );

  // Seats that fit inside included limit
  const includedSeatsAdded =
    seatAction === 'add'
      ? Math.min(userCount, includedSeatsRemaining)
      : 0;

  // Seats charged as add-ons
  const addonSeatsAdded =
    seatAction === 'add'
      ? Math.max(userCount - includedSeatsRemaining, 0)
      : 0;

  const includedSeatsCost =
    Number(preview.includedSeatCharge || 0);

  const includedSeatPrice =
    Number(preview.includedSeatUnitPrice || 0);

  const addonSeatsCost =
    Number(preview.addonSeatCharge || 0);

  const addonSeatPrice =
    Number(preview.addonSeatUnitPrice || 0);

  const includedSeatsAddedApi =
    Number(preview.includedSeatsAdded || 0);

  const addonSeatsAddedApi =
    Number(preview.addonSeatsAdded || 0);

  const isManageOnly =
    isSamePlan &&
    (
      seatAction === null ||
      (seatAction === 'add' && userCount === 0) ||
      (seatAction === 'remove' && removeUsers === 0)
    );

  const isAddUsersFlow =
    isSamePlan &&
    seatAction === 'add' &&
    userCount > 0;

  const isRemoveUsersFlow =
    isSamePlan &&
    seatAction === 'remove' &&
    removeUsers > 0;
  const showTaxes = subtotal > 0 && !isManageOnly;
  const showTotal = subtotal > 0 && !isManageOnly;

  const handleSuccessCallback = (details) => {
    setPaymentDetails({
      amount: displayAmount,
      paymentMode: isSamePlan ? 'ADD_USERS' : paymentMode,
      userCount: addedUsers,
      transactionId: details?.razorpayPaymentId || details?.transactionId || null,
      ...details,
    });

    setPaymentVerifying(true);
    setVerifyStep(0);

    setTimeout(() => {
      setVerifyStep(1);
    }, 1000);

    setTimeout(() => {
      setVerifyStep(2);
    }, 2000);

    setTimeout(() => {
      setPaymentVerifying(false);
      setSuccessOpen(true);
    }, 3000);


  };

  const handleProceed = async () => {
    if (isRemoveUsersFlow) {
      setRemoveConfirmOpen(true);
      return;
    }

    const showUpgradeConfirmation =
      !isSamePlan &&
      (currentPlan?.subscriptionStatus === 'ACTIVE' || currentPlan?.subscriptionStatus === 'EXPIRED') &&
      !currentPlan?.pendingReplacement;

    if (showUpgradeConfirmation) {
      setUpgradeConfirmOpen(true);
      return;
    }

    await proceedUpgrade();
  };

  const proceedUpgrade = async () => {
    if (processing) return;

    setProcessing(true);

    try {
      const finalPaymentMode =
        isSamePlan
          ? currentPlan?.paymentMode || 'MANUAL'
          : paymentMode;

      const usersToSend =
        isSamePlan && seatAction === 'add'
          ? userCount        // only newly added seats
          : finalUsers;      // total users for new subscription/upgrade

      await onProceed(
        plan,
        usersToSend,
        finalPaymentMode,
        enableUsers,
        handleSuccessCallback,
        removeUsers,
        seatAction === 'add',
        useWallet
      );
    } finally {
      setProcessing(false);
    }
  };

  const fmt = (n) => Number(n.toFixed(2)).toLocaleString();

  // ── CTA label (action-consequence pattern, unchanged) ──────────────────
  const ctaLabel = (() => {
    if (loading) return 'Processing…';
    if (removeUsers > 0) return `Remove ${removeUsers} seat${removeUsers > 1 ? 's' : ''} · credit ${symbol}${fmt(walletApplied || 0)}`;
    if (isSamePlan && seatAction === 'add' && userCount > 0) return `Add ${userCount} seat${userCount > 1 ? 's' : ''} · pay ${symbol}${fmt(displayAmount)}`;
    if (isSamePlan) return 'Update subscription';
    if (walletFullyCovers) return 'Confirm · use wallet credits';
    if (finalPayable > 0) return `${isSamePlan ? 'Update' : 'Upgrade'} & pay ${symbol}${fmt(displayAmount)}`;
    return 'Upgrade plan';
  })();

  const ctaDisabled = !!loading || (isSamePlan
    ? seatAction === 'add' ? userCount <= 0 : seatAction === 'remove' ? removeUsers <= 0 : false
    : false);

  const isRemoveAction = removeUsers > 0;
  const ctaBg = isRemoveAction ? '#dc2626' : '#16a34a';
  const ctaBgHover = isRemoveAction ? '#b91c1c' : '#15803d';
  const ac = plan.accentColor;
  const includedRemaining = Math.max(includedUsers - currentPurchasedSeats, 0);
  const addonSeats = Math.max(currentPurchasedSeats - includedUsers, 0);

  const handleCancelPending = async () => {
    try {
      await axiosInstance.post('/rest/dynamic-billing/cancel-pending-replacement');
      window.location.reload();
    } catch (e) {
      console.error(e);
      alert('Failed to cancel pending request');
    }
  };

  // ── Available seats count (unchanged) ──────────────────────────────────
  const availableSeats = isFreePlan
    ? Math.max(includedUsers - currentActiveUsers, 0)
    : Math.max(currentPurchasedSeats - currentActiveUsers, 0);

  // Small badge counts shown on the tab pills so people can tell at a glance
  // which tab currently has an active selection, without opening it.
  const seatsBadge = (seatAction === 'add' && userCount > 0)
    ? `+${userCount}`
    : (removeUsers > 0 ? `-${removeUsers}` : null);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xl"
        fullWidth
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 200 }}
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden',
            border: '1px solid',
            borderColor: 'divider',

            width: '96vw',
            maxWidth: '1080px',

            height: 'min(600px,96vh)',
            maxHeight: '96vh',

            display: 'flex',
            flexDirection: 'column',

            boxShadow: '0 24px 64px rgba(0,0,0,.12)',

            m: 1,

            bgcolor: 'background.paper',
          },
        }}

        slotProps={{ backdrop: { sx: { backdropFilter: 'blur(6px)', bgcolor: 'rgba(0,0,0,0.3)' } } }}
      >
        {/* ══ HEADER ══════════════════════════════════════════════════════ */}
        <Box sx={{
          px: { xs: 2, md: 2.5 }, py: 1.5,
          borderBottom: '0.5px solid', borderColor: 'divider',
          bgcolor: 'background.paper', flexShrink: 0,
        }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Box sx={{
                width: 34, height: 34, borderRadius: '10px', flexShrink: 0,
                bgcolor: 'primary.lighter', color: 'primary.main',
                border: '0.5px solid', borderColor: 'divider',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.95rem',
              }}>
                {plan.icon}
              </Box>
              <Box>
                <Typography sx={{ fontSize: '0.88rem', fontWeight: 600, color: 'text.primary', letterSpacing: '-0.02em', lineHeight: 1.2 }}>
                  {isSamePlan ? `Manage subscription · ${plan.name}` : `Upgrade to ${plan.name}`}
                </Typography>
                <Typography sx={{ fontSize: '0.68rem', color: 'text.secondary', mt: 0.15 }}>
                  {isSamePlan ? 'Add or remove seats on your current plan' : 'Review your order before payment'}
                </Typography>
              </Box>
            </Stack>
            <IconButton onClick={onClose} size="small" sx={{ width: 26, height: 26, borderRadius: '8px', color: 'text.secondary', '&:hover': { bgcolor: 'action.hover' } }}>
              <CloseRounded sx={{ fontSize: '0.85rem' }} />
            </IconButton>
          </Stack>
        </Box>

        {/* ══ TAB BAR ═════════════════════════════════════════════════════ */}
        <Box sx={{
          px: { xs: 2, md: 2.5 }, py: 1,
          borderBottom: '0.5px solid', borderColor: 'divider',
          bgcolor: '#f8fafc', flexShrink: 0,
        }}>
          <Stack direction="row" spacing={0.5} sx={{ bgcolor: 'action.hover', borderRadius: '10px', p: 0.4, width: 'fit-content' }}>
            {!isSamePlan && (
              <TabButton label="Plan" active={activeTab === 'plan'} onClick={() => setActiveTab('plan')} />
            )}
            {isSamePlan && (
              <TabButton label="Seats" active={activeTab === 'seats'} onClick={() => setActiveTab('seats')} badge={seatsBadge} />
            )}
            <TabButton label="Billing" active={activeTab === 'billing'} onClick={() => setActiveTab('billing')} />
          </Stack>
        </Box>

        {isSamePlan && (isExpired || isExpiringSoon) && (
          <Box
            sx={{
              mx: { xs: 2, md: 2.5 },
              mt: 1.5,
              mb: 0.5,
              p: 1.25,
              borderRadius: '8px',
              bgcolor: (theme) => alpha(theme.palette[isExpired ? 'error' : 'warning'].main, 0.08),
              border: '1px solid',
              borderColor: (theme) => alpha(theme.palette[isExpired ? 'error' : 'warning'].main, 0.2),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 2,
              flexShrink: 0,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              {isExpired ? (
                <ErrorOutline sx={{ color: 'error.main', flexShrink: 0, fontSize: 18 }} />
              ) : (
                <WarningAmberOutlined sx={{ color: 'warning.main', flexShrink: 0, fontSize: 18 }} />
              )}
              <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary', fontWeight: 500 }}>
                <strong style={{ color: isExpired ? '#dc2626' : '#b91c1c' }}>
                  {isExpired ? 'Subscription Expired:' : 'Expiring Soon:'}
                </strong>{' '}
                {isExpired
                  ? `Your subscription for the ${plan?.name} Plan has expired. Renew now to prevent disruption.`
                  : `Your subscription for the ${plan?.name} Plan expires in ${currentPlan?.remainingDays} days. Renew early to lock in your rate.`}
              </Typography>
            </Stack>
            <Button
              size="small"
              variant="contained"
              color={isExpired ? 'error' : 'warning'}
              onClick={onRenewClick}
              sx={{
                whiteSpace: 'nowrap',
                fontWeight: 700,
                fontSize: '0.68rem',
                borderRadius: '6px',
                px: 1.5,
                py: 0.5,
                textTransform: 'none',
              }}
            >
              {isExpired ? 'Renew Plan' : 'Renew Early'}
            </Button>
          </Box>
        )}

        {/* ══ BODY ════════════════════════════════════════════════════════ */}
        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, position: 'relative' }}>

          {/* ── LEFT PANE — active tab content only ───────────────────── */}
          <Box sx={{
            flex: 1, minWidth: 0, minHeight: 0, overflowY: 'auto',
            p: { xs: 1.75, md: 2 },
            borderRight: { md: '0.5px solid' }, borderColor: { md: 'divider' },
            bgcolor: '#f8fafc',
            display: 'flex', flexDirection: 'column', gap: 1.25,
            '&::-webkit-scrollbar': { width: 3 },
            '&::-webkit-scrollbar-thumb': { bgcolor: 'divider', borderRadius: 4 },
          }}>

            {/* ── PLAN TAB ── */}
            {activeTab === 'plan' && !isSamePlan && (
              <>
                <Box sx={{
                  p: 1.75, borderRadius: '12px',
                  bgcolor: `${ac}07`, border: '0.5px solid', borderColor: `${ac}20`,
                }}>
                  <Stack direction="row" spacing={1} alignItems="center" mb={0.75}>
                    <Chip label={(currentPlan?.subscriptionStatus === 'TRIAL' || currentPlan?.paymentMode === 'TRIAL') ? 'Trial' : currentPlan?.planName} size="small" sx={{ height: 20, fontSize: '0.68rem', fontWeight: 600, bgcolor: 'action.hover', color: 'text.secondary', border: '0.5px solid', borderColor: 'divider', '& .MuiChip-label': { px: 0.9 } }} />
                    <ArrowForward sx={{ fontSize: 13, color: 'text.disabled' }} />
                    <Chip label={plan.name} size="small" sx={{ height: 20, fontSize: '0.68rem', fontWeight: 600, bgcolor: `${ac}12`, color: ac, border: `0.5px solid ${ac}25`, '& .MuiChip-label': { px: 0.9 } }} />
                  </Stack>
                  <Typography sx={{ fontSize: '0.76rem', color: 'text.secondary', lineHeight: 1.6 }}>
                    All <strong style={{ color: 'inherit' }}>{currentPlan?.userCount || currentActiveUsers}</strong> existing users
                    will keep access after upgrading to <strong style={{ color: 'inherit' }}>{plan.name}</strong>.
                  </Typography>
                </Box>

                <SectionCard>
                  <CardHeader
                    icon={<PersonAddOutlined sx={{ fontSize: 13, color: 'text.secondary' }} />}
                    title="Plan capacity"
                    subtitle={`${includedUsers} Plan Seats`}
                  />
                  <Stack direction="row" spacing={1} sx={{ p: 1.5 }}>
                    <SeatStat value={currentPurchasedSeats + userCount} label="Total seats" />
                    <SeatStat value={Math.min(currentPurchasedSeats + userCount, includedUsers)} label="Plan seats" color="#16a34a" />
                    <SeatStat value={Math.max((currentPurchasedSeats + userCount) - includedUsers, 0)} label="Add-on seats" color="#d97706" />
                  </Stack>
                </SectionCard>

                <SectionCard>
                  <CardHeader
                    icon={<PersonAddOutlined sx={{ fontSize: 13, color: ac }} />}
                    title="Additional users"
                    subtitle="Add users before upgrading"
                  />

                  <Box sx={{ p: 2 }}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 600,
                          }}
                        >
                          New total users
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "0.68rem",
                            color: "text.secondary",
                          }}
                        >
                          {currentPurchasedSeats + userCount} users after upgrade
                        </Typography>
                      </Box>

                      <CounterControl
                        value={userCount}
                        onChange={setUserCount}
                      />
                    </Stack>
                  </Box>
                </SectionCard>

              </>
            )}

            {/* ── SEATS TAB (same-plan holders only) ── */}
            {activeTab === 'seats' && isSamePlan && (
              <>
                <SectionCard>
                  <CardHeader
                    icon={<PersonAddOutlined sx={{ fontSize: 13, color: 'text.secondary' }} />}
                    title="Seat summary"
                    subtitle={`${currentPurchasedSeats} purchased · ${includedRemaining} Plan Seats remaining`}
                  />
                  <Stack direction="row" spacing={1} sx={{ p: 1.5 }}>
                    <SeatStat value={currentPurchasedSeats} label="Purchased seats" />
                    <SeatStat value={includedRemaining} label="Plan Seats remaining" color="#16a34a" />
                    <SeatStat value={addonSeats} label="Add-on seats" color="#d97706" />
                  </Stack>
                </SectionCard>

                <SectionCard
                  highlighted={seatAction === 'add' || seatAction === 'remove'}
                  highlightColor={seatAction === 'remove' ? '#dc2626' : ac}
                >
                  <CardHeader
                    icon={
                      seatAction === 'remove'
                        ? <PersonRemoveOutlined sx={{ fontSize: 13, color: '#dc2626' }} />
                        : <PersonAddOutlined sx={{ fontSize: 13, color: ac }} />
                    }
                    title="Manage seats"
                    subtitle={`${currentPurchasedSeats} seats currently purchased`}
                  />

                  <Box sx={{ p: 1.75 }}>
                    <Stack direction="row" spacing={1} sx={{ mb: 1.75 }} justifyContent="flex-start">
                      <Button
                        fullWidth
                        variant={seatAction === 'add' ? 'contained' : 'outlined'}
                        onClick={() => { setSeatAction('add'); setRemoveUsers(0); }}
                        color="success"
                        sx={{ borderRadius: '10px', textTransform: 'none', fontSize: '0.78rem' }}
                      >
                        Add seats
                      </Button>

                      {currentPurchasedSeats > 1 && (
                        <Button
                          fullWidth
                          variant={seatAction === 'remove' ? 'contained' : 'outlined'}
                          color="error"
                          onClick={() => { setSeatAction('remove'); setUserCount(0); }}
                          sx={{ borderRadius: '10px', textTransform: 'none', fontSize: '0.78rem' }}
                        >
                          Remove seats
                        </Button>
                      )}
                    </Stack>

                    {seatAction === 'add' && (
                      <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Box>
                          <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>New total seats</Typography>
                          <Typography sx={{ fontSize: '0.68rem', color: 'text.secondary' }}>
                            {currentPurchasedSeats + userCount} seats after upgrade
                          </Typography>
                        </Box>
                        <CounterControl value={userCount} onChange={setUserCount} />
                      </Stack>
                    )}

                    {seatAction === 'remove' && (
                      <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Box>
                          <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#dc2626' }}>Seats to remove</Typography>
                          <Typography sx={{ fontSize: '0.68rem', color: 'text.secondary' }}>
                            Wallet credit will be applied automatically
                          </Typography>
                        </Box>
                        <CounterControl
                          value={removeUsers}
                          onChange={setRemoveUsers}
                          max={currentPurchasedSeats - 1}
                          colorScheme="red"
                        />
                      </Stack>
                    )}

                    {seatAction === null && (
                      <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary', textAlign: 'center', py: 1 }}>
                        Choose "Add seats" or "Remove seats" to make a change.
                      </Typography>
                    )}
                  </Box>
                </SectionCard>
              </>
            )}

            {/* ── BILLING TAB ── */}
            {activeTab === 'billing' && (
              <>
                {!isSamePlan && (
                  <SectionCard>
                    <CardHeader
                      icon={<PaymentsOutlined sx={{ fontSize: 13, color: 'text.secondary' }} />}
                      title="Payment Method"
                      subtitle="Choose your preferred payment method"
                      action={
                        <Tooltip arrow placement="left" title={
                          <Box sx={{ p: 0.5 }}>
                            <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, mb: 0.5 }}>Payment Methods</Typography>
                            <Typography sx={{ fontSize: '0.68rem', lineHeight: 1.6 }}><strong>Manual Invoice:</strong> Pay via bank transfer upon receiving invoice.</Typography>
                            <Typography sx={{ fontSize: '0.68rem', lineHeight: 1.6, mt: 0.4 }}><strong>Auto-Debit:</strong> Automatically charge saved credit card.</Typography>
                          </Box>
                        }>
                          <IconButton size="small" sx={{ width: 22, height: 22, bgcolor: 'info.lighter', color: 'info.main', border: '0.5px solid', borderColor: 'info.light', '&:hover': { bgcolor: 'info.lighter' } }}>
                            <InfoOutlined sx={{ fontSize: '0.72rem' }} />
                          </IconButton>
                        </Tooltip>
                      }
                    />
                    <Stack direction="row" spacing={1} sx={{ p: 1.5 }}>
                      <PaymentModeCard mode="MANUAL" selected={paymentMode === 'MANUAL'} onClick={() => setPaymentMode('MANUAL')} billingCycle={billingCycle} />
                      <PaymentModeCard mode="AUTO_DEBIT" selected={paymentMode === 'AUTO_DEBIT'} onClick={() => setPaymentMode('AUTO_DEBIT')} billingCycle={billingCycle} />
                    </Stack>
                  </SectionCard>
                )}

                {isSamePlan && (
                  <SectionCard>
                    <CardHeader
                      icon={<PaymentsOutlined sx={{ fontSize: 13, color: 'text.secondary' }} />}
                      title="Billing Details"
                      borderless
                    />
                    <Stack spacing={0.5} sx={{ px: 1.75, pb: 1.5 }}>
                      <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary' }}>
                        <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>Payment Method: </Box>
                        {currentPlan?.paymentMode === 'MANUAL' ? 'Manual Invoice' : 'Auto-Debit'} (carried from active subscription)
                      </Typography>
                      <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary' }}>
                        <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>Billing Cycle: </Box>
                        {isAnnual ? 'Annually' : 'Monthly'} (updates take effect at next renewal)
                      </Typography>
                    </Stack>
                  </SectionCard>
                )}

                <Box sx={{
                  px: 1.75, py: 1, borderRadius: '10px',
                  bgcolor: isAnnual ? 'rgba(22, 163, 74, 0.05)' : 'rgba(2, 136, 209, 0.05)',
                  border: '1px solid', borderColor: isAnnual ? 'rgba(22, 163, 74, 0.15)' : 'rgba(2, 136, 209, 0.15)',
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                  <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: isAnnual ? 'success.dark' : 'info.dark' }}>
                    {isAnnual ? '✓ Annual Billing Cycle · 20% platform discount applied' : '✓ Monthly Billing Cycle'}
                  </Typography>
                  <Chip size="small" label={isAnnual ? 'Annual · 20% Off' : 'Monthly'} color={isAnnual ? 'success' : 'info'} sx={{ height: 18, fontSize: '0.6rem', fontWeight: 700 }} />
                </Box>
              </>
            )}
          </Box>

          {/* ── RIGHT PANE — Order Summary (pinned, always visible) ────── */}
          <Box
            sx={{
              width: { xs: '100%', md: 460 },
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              borderTop: { xs: '0.5px solid', md: 'none' },
              bgcolor: 'background.paper',
            }}
          >

            {previewLoading && (
              <Box
                sx={{
                  position: 'absolute', inset: 0, zIndex: 20,
                  bgcolor: 'rgba(255,255,255,0.75)', backdropFilter: 'blur(3px)',
                  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1,
                }}
              >
                <CircularProgress size={26} thickness={4} sx={{ color: ac }} />
                <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary' }}>
                  {loadingMessages[messageIndex]}
                </Typography>
              </Box>
            )}

            {/* Sticky Header */}
            <Box sx={{ p: 1.75, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
              <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: 'text.primary', mb: 0.3 }}>Order summary</Typography>
              <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary' }}>
                {isAnnual ? 'Billed annually · renews in 12 months' : 'Billed monthly · renews each month'}
              </Typography>
            </Box>

            <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', p: 1.75, '&::-webkit-scrollbar': { width: 3 }, '&::-webkit-scrollbar-thumb': { bgcolor: 'divider', borderRadius: 4 } }}>

              {isManageOnly ? (

                <Box
                  sx={{
                    height: '100%',
                    minHeight: 320,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    p: 4,
                  }}
                >
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: '50%',
                      bgcolor: 'background.paper',
                      border: '1px solid',
                      borderColor: 'divider',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 2.5,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                    }}
                  >
                    <InfoOutlined sx={{ fontSize: 24, color: 'info.main' }} />
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: '0.95rem',
                      color: 'text.primary',
                      mb: 1,
                    }}
                  >
                    No Changes Selected
                  </Typography>

                  <Typography
                    sx={{
                      color: 'text.secondary',
                      fontSize: '0.78rem',
                      lineHeight: 1.6,
                      maxWidth: 280,
                      mx: 'auto',
                    }}
                  >
                    Adjust the number of seats using <Box component="span" sx={{ color: 'success.main', fontWeight: 'bold' }}>Add seats</Box> or <Box component="span" sx={{ color: 'error.main', fontWeight: 'bold' }}>Remove seats</Box> to update your subscription details.
                  </Typography>
                </Box>

              ) : (

                <Stack spacing={1}>

                  {/* ── PLATFORM FEE ── */}
                  {!isSamePlan &&
                    !isManageOnly &&
                    !isRemoveUsersFlow &&
                    Number(preview.baseAmount || 0) > 0 && (
                      <Box sx={{ p: 1.25, borderRadius: '10px', bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}>
                        <SectionLabel>Platform fee</SectionLabel>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 0.2 }}>
                          <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary' }}>
                            {isSamePlan
                              ? 'Platform fee (monthly)'
                              : isAnnual
                                ? `${plan?.name} plan fee (billed annually)`
                                : `${plan?.name} plan fee`}
                          </Typography>
                          <Stack direction="row" spacing={1} alignItems="center">
                            {isAnnual && (
                              <Typography sx={{ fontSize: '0.72rem', color: 'text.disabled', textDecoration: 'line-through', mr: 0.5 }}>
                                {symbol}{fmt(((currency === 'INR' ? plan?.basePriceINR : plan?.basePriceUSD) || 0) * 12)}
                              </Typography>
                            )}
                            <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: isAnnual ? 'success.main' : 'inherit' }}>
                              {symbol}{fmt(Number(preview.baseAmount || 0))}
                            </Typography>
                            {currentPlan?.subscriptionStatus === 'ACTIVE' &&
                              currentPlan?.baseAmount > 0 &&
                              isSamePlan && (
                                <Chip label="Paid" size="small" color="success" sx={{ height: 16, fontSize: '0.55rem', fontWeight: 700 }} />
                              )}
                          </Stack>
                        </Stack>
                      </Box>
                    )}
                  {/* ── USER SEATS ── */}
                  {!isManageOnly && !isRemoveUsersFlow && (
                    <Box
                      sx={{
                        p: 1.25,
                        borderRadius: '10px',
                        bgcolor: 'background.paper',
                        border: '1px solid',
                        borderColor: 'divider',
                      }}
                    >
                      <SectionLabel>
                        {isSamePlan ? "Today's Purchase" : "User Seats"}
                      </SectionLabel>

                      {/* ==============================
                          MANAGE SEATS (ADD USERS)
                      ============================== */}
                      {isSamePlan ? (
                        <>
                          {Number(preview.includedSeatsAdded || 0) > 0 && (
                            <SummaryRow
                              label={`Plan Seats Added (${preview.includedSeatsAdded}) × ${symbol}${fmt(
                                Number(preview.includedSeatCharge || 0) / Number(preview.includedSeatsAdded || 1)
                              )}`}
                              value={`${symbol}${fmt(preview.includedSeatCharge)}`}
                              valueColor="success.main"
                            />
                          )}

                          {Number(preview.addonSeatsAdded || 0) > 0 && (
                            <SummaryRow
                              label={`Add-on Seats (${preview.addonSeatsAdded}) × ${symbol}${fmt(
                                Number(preview.addonSeatCharge || 0) / Number(preview.addonSeatsAdded || 1)
                              )}`}
                              value={`${symbol}${fmt(preview.addonSeatCharge)}`}
                              valueColor="warning.main"
                            />
                          )}

                          <Box
                            sx={{
                              mt: 1.5,
                              p: 1.25,
                              borderRadius: 1,
                              bgcolor: 'action.hover',
                              border: '1px solid',
                              borderColor: 'divider',
                            }}
                          >
                            <Typography
                              fontSize={12}
                              color="text.secondary"
                            >
                              {Number(preview.addonSeatsAdded || 0) > 0
                                ? `${preview.addonSeatsAdded} seat${preview.addonSeatsAdded > 1 ? "s" : ""
                                } will be billed as add-on seats.`
                                : "All added seats are Plan Seats."}
                            </Typography>
                          </Box>
                        </>
                      ) : (
                        <>
                          {/* ==============================
                            NEW PLAN / UPGRADE
                        ============================== */}

                          {Number(preview.includedUsersAmount || 0) > 0 && (
                            <SummaryRow
                              label={
                                isAnnual
                                  ? `Plan Users • ${preview.includedUsers} × ${symbol}${fmt(
                                    (Number(preview.includedUsersAmount) /
                                      Number(preview.includedUsers)) / 12
                                  )} / month`
                                  : `Plan Users • ${preview.includedUsers} × ${symbol}${fmt(
                                    Number(preview.includedUsersAmount) /
                                    Number(preview.includedUsers)
                                  )}`
                              }
                              value={`${symbol}${fmt(
                                Number(preview.includedUsersAmount)
                              )}`}
                            />
                          )}

                          {Number(preview.addonUsersAmount || 0) > 0 && (
                            <SummaryRow
                              label={
                                isAnnual
                                  ? `Add-on Users • ${preview.addonUsers} × ${symbol}${fmt(
                                    (Number(preview.addonUsersAmount) /
                                      Number(preview.addonUsers)) / 12
                                  )} / month`
                                  : `Add-on Users • ${preview.addonUsers} × ${symbol}${fmt(
                                    Number(preview.addonUsersAmount) /
                                    Number(preview.addonUsers)
                                  )}`
                              }
                              value={`${symbol}${fmt(
                                Number(preview.addonUsersAmount)
                              )}`}
                              valueColor="warning.main"
                            />
                          )}

                          {seatAction === "add" && (
                            <Box
                              sx={{
                                mt: 1.5,
                                p: 1.25,
                                borderRadius: 1,
                                bgcolor: 'action.hover',
                                border: '1px solid',
                                borderColor: 'divider',
                              }}
                            >
                              <Typography
                                fontSize={12}
                                color="text.secondary"
                              >
                                {totalAddonUsers > 0
                                  ? `Your plan has ${preview.includedUsers} Plan Users. ${totalAddonUsers} user${totalAddonUsers > 1 ? "s are" : " is"
                                  } billed as add-on seat${totalAddonUsers > 1 ? "s" : ""
                                  }.`
                                  : "All users are within your Plan User limit."}
                              </Typography>
                            </Box>
                          )}
                        </>
                      )}

                      {isRemoveUsersFlow && (
                        <SummaryRow
                          label={`Seats removed (${removeUsers})`}
                          value={`− ${symbol}${fmt(walletApplied || 0)}`}
                          valueColor="success.main"
                        />
                      )}
                    </Box>
                  )}

                  {/* ── SUBTOTAL / CREDITS ── */}
                  {!isManageOnly &&
                    !isRemoveUsersFlow && (
                      <Box sx={{ p: 1.25, borderRadius: '10px', bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}>
                        <SectionLabel>Subtotal</SectionLabel>
                        <SummaryRow label="Subtotal before tax" value={`${symbol}${fmt(subtotal)}`} />
                      </Box>
                    )}

                  {/* ── TAXES ── */}
                  {!isRemoveUsersFlow &&
                    showTaxes && (
                      <Box sx={{ p: 1.25, borderRadius: '10px', bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}>
                        <SectionLabel>Taxes</SectionLabel>
                        <SummaryRow label="GST (18%) on subtotal" value={`${symbol}${fmt(gstAmount)}`} />
                      </Box>
                    )}

                  {/* ── COUPON ── */}
                  {!isManageOnly && !isRemoveUsersFlow && (
                    <Box sx={{ p: 1.25, borderRadius: '10px', bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', mt: 1 }}>
                      <SectionLabel>Promo Code</SectionLabel>
                      {preview?.couponApplied && Number(preview.discountAmount || 0) > 0 ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <Stack>
                             <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: 'success.main' }}>
                               Coupon '{preview.couponCode}' Applied
                               <Typography
                                 component="span"
                                 sx={{ ml: 1, fontSize: '0.65rem', color: 'error.main', cursor: 'pointer', textDecoration: 'underline' }}
                                 onClick={() => {
                                   setCouponCode('');
                                   setCouponInput('');
                                 }}
                               >
                                 Remove
                               </Typography>
                             </Typography>
                             <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary' }}>
                               Discount amount
                             </Typography>
                          </Stack>
                          <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: 'success.main' }}>
                            -{symbol}{fmt(Number(preview.discountAmount))}
                          </Typography>
                        </Box>
                      ) : (
                        <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                          <TextField
                            size="small"
                            placeholder="Have a promo code?"
                            value={couponInput}
                            onChange={(e) => setCouponInput(e.target.value.toUpperCase())}
                            sx={{
                              flex: 1,
                              '& .MuiInputBase-root': { height: 32, fontSize: '0.75rem' },
                            }}
                          />
                          <Button
                            variant="outlined"
                            disabled={!couponInput.trim()}
                            onClick={() => {
                              setCouponCode(couponInput.trim());
                            }}
                            sx={{ height: 32, fontSize: '0.75rem' }}
                          >
                            Apply
                          </Button>
                        </Stack>
                      )}
                      
                      {couponCode && !preview?.couponApplied && !previewLoading && (
                        <Typography sx={{ mt: 1, fontSize: '0.75rem', color: 'error.main' }}>
                          {preview?.couponError || 'Invalid or expired coupon code.'}
                        </Typography>
                      )}
                    </Box>
                  )}

                  {walletBalance > 0 && !isRemoveUsersFlow && (
                    <Box
                      sx={{
                        mt: 1,
                        p: 1.25,
                        borderRadius: '10px',
                        bgcolor: 'background.paper',
                        border: '1px solid',
                        borderColor: 'divider',
                        cursor: "pointer",
                        transition: "0.2s",
                      }}
                      onClick={() => setUseWallet(!useWallet)}
                    >
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Stack direction="row" spacing={1.25} alignItems="center">
                          <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 32,
                            height: 32,
                            borderRadius: '8px',
                            bgcolor: 'primary.lighter',
                            color: 'primary.main'
                          }}>
                            <AccountBalanceWalletOutlined sx={{ fontSize: '1.1rem' }} />
                          </Box>
                          <Box>
                            <Typography
                              fontWeight={700}
                              fontSize="0.8rem"
                            >
                              Apply Wallet Credits
                            </Typography>
                            <Typography
                              fontSize="0.72rem"
                              color="text.secondary"
                            >
                              Available: <Box component="span" sx={{ color: 'success.main', fontWeight: 700 }}>{symbol}{fmt(walletBalance)}</Box>
                            </Typography>
                          </Box>
                        </Stack>

                        <Switch
                          checked={useWallet}
                          size="small"
                          color="primary"
                          onClick={(e) => { e.stopPropagation(); setUseWallet(!useWallet); }}
                        />
                      </Stack>

                      {useWallet && walletApplied > 0 && (
                        <Box
                          sx={{
                            mt: 1,
                            pt: 1,
                            borderTop: "1px dashed",
                            borderColor: 'divider',
                          }}
                        >
                          <SummaryRow
                            label="Wallet Applied"
                            value={`-${symbol}${fmt(walletApplied)}`}
                            valueColor="success.main"
                          />
                        </Box>
                      )}
                    </Box>
                  )}

                  {/* Remove Seats Summary */}

                  {isRemoveUsersFlow && (
                    <Box
                      sx={{
                        p: 1.25,
                        borderRadius: '10px',
                        bgcolor: 'background.paper',
                        border: '1px solid',
                        borderColor: 'divider',
                      }}
                    >
                      <SectionLabel>Wallet Credit</SectionLabel>

                      <SummaryRow
                        label="Seats to remove"
                        value={removeUsers}
                      />

                      <SummaryRow
                        label="Wallet Credit"
                        value={`+${symbol}${fmt(walletApplied)}`}
                        valueColor="success.main"
                      />

                      <SummaryRow
                        label="Current Wallet"
                        value={`${symbol}${fmt(walletBalance)}`}
                      />

                      <SummaryRow
                        label="New Wallet Balance"
                        value={`${symbol}${fmt(walletBalance + walletApplied)}`}
                        isTotal
                        valueColor="success.main"
                      />

                      <Typography
                        sx={{
                          mt: 1.5,
                          fontSize: "0.72rem",
                          color: "success.main",
                        }}
                      >
                        ✓ Wallet credit will be added immediately after confirmation.
                      </Typography>
                    </Box>
                  )}


                </Stack>
              )}
            </Box>

            {/* TOTAL */}
            {showTotal && (
              <Box sx={{
                p: 1.75, borderTop: '0.5px solid', borderColor: 'divider',
                bgcolor: 'background.neutral', flexShrink: 0,
                textAlign: 'right',
              }}>
                <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, color: 'text.disabled', letterSpacing: '0.07em', textTransform: 'uppercase', mb: 0.4 }}>
                  Total due today
                </Typography>
                {walletFullyCovers && (
                  <Typography sx={{ fontSize: '0.65rem', color: 'success.main', fontWeight: 600, mb: 0.2 }}>
                    Fully covered by wallet
                  </Typography>
                )}
                <Stack direction="row" alignItems="baseline" spacing={0.25} justifyContent="flex-end">
                  <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: walletFullyCovers ? 'success.main' : 'primary.main', alignSelf: 'flex-start', mt: 0.3 }}>{symbol}</Typography>
                  <Typography sx={{ fontSize: '1.6rem', fontWeight: 700, color: walletFullyCovers ? 'success.main' : 'primary.main', letterSpacing: '-0.04em', lineHeight: 1 }}>
                    {fmt(displayAmount)}
                  </Typography>
                </Stack>
                {currentPlan?.paymentMode === 'AUTO_DEBIT' && recurringAmount > 0 && (
                  <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary', mt: 0.6 }}>
                    Next renewal · {symbol}{fmt(recurringAmount)}/{isAnnual ? 'yr' : 'mo'}
                  </Typography>
                )}
                {!isRemoveAction && recurringAmount > 0 && (
                  <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary', mt: 0.2 }}>
                    {plan.name} · renews {isAnnual ? 'annually' : 'monthly'}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </Box>

        {/* ══ FOOTER ══════════════════════════════════════════════════════ */}
        <Box sx={{ px: { xs: 2, md: 2.5 }, py: 1.25, borderTop: '0.5px solid', borderColor: 'divider', bgcolor: 'background.paper', flexShrink: 0 }}>
          <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center" flexWrap="wrap">
            {currentPlan?.pendingReplacement && (
              <Button color="error" variant="outlined" onClick={handleCancelPending} size="small" sx={{ borderRadius: '8px', fontSize: '0.75rem', mr: 'auto' }}>
                Cancel pending request
              </Button>
            )}
            <Button
              onClick={onClose}
              variant="outlined"
              size="small"
              sx={{
                borderRadius: '8px', px: 2, py: 0.75, fontWeight: 500, fontSize: '0.78rem',
                color: 'text.secondary', borderColor: 'divider',
                '&:hover': { bgcolor: 'action.hover', borderColor: 'text.secondary' },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleProceed}
              disabled={ctaDisabled || previewLoading}
              variant="contained"
              size="small"
              color={isRemoveAction ? 'error' : 'primary'}
              disableElevation
              endIcon={!loading && <ArrowForwardRounded sx={{ fontSize: '0.85rem !important' }} />}
              sx={{
                borderRadius: '8px', px: 2.25, py: 0.8,
                minWidth: { xs: '100%', sm: 200 },
                fontWeight: 600, fontSize: '0.78rem',
              }}
            >
              {ctaLabel}
            </Button>
          </Stack>
        </Box>
      </Dialog>

      {/* ══ UPGRADE CONFIRMATION DIALOG ═══════════════════════════════ */}
      <Dialog
        open={upgradeConfirmOpen}
        onClose={() => setUpgradeConfirmOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '24px',
            overflow: 'hidden',
            boxShadow: '0 24px 80px rgba(0,0,0,0.15)',
            maxHeight: 'min(580px, 92vh)',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.neutral',
            borderBottom: '1px solid',
            borderColor: 'divider',
            p: 2,
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 48, height: 48, borderRadius: '14px',
                bgcolor: 'primary.main',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#fff', fontSize: '1.25rem',
              }}
            >
              🚀
            </Box>
            <Box>
              <Typography sx={{ fontSize: '1.05rem', fontWeight: 700 }}>Confirm plan upgrade</Typography>
              <Typography sx={{ fontSize: '0.76rem', color: 'text.secondary' }}>Review the changes before continuing</Typography>
            </Box>
          </Stack>
        </Box>

        <DialogContent sx={{ p: 2, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
          {(() => {
            const unusedCreditVal = Number(preview?.unusedCredit || 0);
            const isPlanExpired = currentPlan?.subscriptionStatus === 'EXPIRED';

            return (
              <>
                {!isFreePlan && (
                  <Box sx={{
                    p: 1.5,
                    borderRadius: '16px',
                    bgcolor: isPlanExpired ? 'rgba(239, 68, 68, 0.06)' : 'rgba(245, 158, 11, 0.06)',
                    border: '1px dashed',
                    borderColor: isPlanExpired ? 'error.light' : 'warning.light',
                    mb: 1.5
                  }}>
                    <Typography sx={{
                      fontWeight: 600,
                      fontSize: '0.76rem',
                      lineHeight: 1.5,
                      color: isPlanExpired ? 'error.main' : 'warning.main',
                      display: 'flex',
                      gap: 1,
                      alignItems: 'flex-start'
                    }}>
                      <span>⚠️</span>
                      {isPlanExpired ? (
                        `Changing your plan will activate your new plan starting today. Since your current plan is expired, no unused credit will be added to your wallet.`
                      ) : (
                        `Changing your plan will end your current plan today. The unused amount of ${symbol}${fmt(unusedCreditVal)} will be credited to your tenant wallet immediately.`
                      )}
                    </Typography>
                  </Box>
                )}

                <Box sx={{ p: 1.5, borderRadius: '16px', bgcolor: 'background.neutral', border: '1px solid', borderColor: 'divider', mb: 1.5 }}>
                  <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
                    <Chip label={(currentPlan?.subscriptionStatus === 'TRIAL' || currentPlan?.paymentMode === 'TRIAL') ? 'Trial' : currentPlan?.planName} size="small" sx={{ fontWeight: 700 }} />
                    <ArrowForwardRounded sx={{ color: 'primary.main', fontSize: '1.1rem' }} />
                    <Chip label={plan?.name} size="small" sx={{ bgcolor: 'primary.lighter', color: 'primary.main', fontWeight: 700 }} />
                  </Stack>
                  <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 1.5 }}>
                    <Chip size="small" label={`${currentPlan?.remainingDays || 0} days remaining`} color="success" variant="outlined" />
                    {currentPlan?.billingEndDate && currentPlan.billingEndDate !== 'null' && (
                      <Chip size="small" label={`Expires ${currentPlan?.billingEndDate}`} color="info" variant="outlined" />
                    )}
                  </Stack>
                </Box>

                <Box sx={{ p: 1.75, borderRadius: '16px', bgcolor: 'background.neutral', border: '1px solid', borderColor: 'divider' }}>
                  <Typography sx={{ fontWeight: 700, fontSize: '0.82rem', mb: 1, color: 'success.main' }}>
                    What happens after upgrade?
                  </Typography>
                  <Stack spacing={1}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Box sx={{ color: 'success.main', fontSize: '0.85rem' }}>✓</Box>
                      <Typography fontSize="0.76rem">Existing users will continue access</Typography>
                    </Stack>
                    {!isFreePlan && (
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Box sx={{ color: 'success.main', fontSize: '0.85rem' }}>✓</Box>
                        <Typography fontSize="0.76rem">
                          {isPlanExpired ? (
                            "No unused credit will be added (current plan is expired)"
                          ) : (
                            `Unused subscription value of ${symbol}${fmt(unusedCreditVal)} will be credited to your wallet`
                          )}
                        </Typography>
                      </Stack>
                    )}
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Box sx={{ color: 'success.main', fontSize: '0.85rem' }}>✓</Box>
                      <Typography fontSize="0.76rem">Future renewals will happen on the new plan</Typography>
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Box sx={{ color: 'success.main', fontSize: '0.85rem' }}>✓</Box>
                      <Typography fontSize="0.76rem">No users, data or settings will be lost</Typography>
                    </Stack>
                  </Stack>
                </Box>
              </>
            );
          })()}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
          <Button variant="outlined" color="error" size="small" onClick={() => setUpgradeConfirmOpen(false)} sx={{ borderRadius: '12px', px: 2.5 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            disableElevation
            onClick={() => { setUpgradeConfirmOpen(false); proceedUpgrade(); }}
            sx={{ borderRadius: '12px', px: 2.5, fontWeight: 700 }}
          >
            Continue & pay {symbol}{fmt(displayAmount)}
          </Button>
        </DialogActions>
      </Dialog>
      {/* ══ SEAT REMOVAL CONFIRMATION DIALOG ═══════════════════════════════ */}
      <Dialog
        open={removeConfirmOpen}
        onClose={() => setRemoveConfirmOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '24px',
            overflow: 'hidden',
            boxShadow: '0 24px 80px rgba(0,0,0,0.15)',
            maxHeight: 'min(580px, 92vh)',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.neutral',
            borderBottom: '1px solid',
            borderColor: 'divider',
            p: 2,
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 48, height: 48, borderRadius: '14px',
                bgcolor: 'error.main',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#fff', fontSize: '1.25rem',
              }}
            >
              🗑️
            </Box>
            <Box>
              <Typography sx={{ fontSize: '1.05rem', fontWeight: 700 }}>Confirm seat removal</Typography>
              <Typography sx={{ fontSize: '0.76rem', color: 'text.secondary' }}>Review the impacts of removing users</Typography>
            </Box>
          </Stack>
        </Box>

        <DialogContent sx={{ p: 2, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ p: 1.5, borderRadius: '16px', bgcolor: 'rgba(239, 68, 68, 0.06)', border: '1px dashed', borderColor: 'error.light', mb: 1.5 }}>
            <Typography sx={{ fontWeight: 600, fontSize: '0.76rem', lineHeight: 1.5, color: 'error.main', display: 'flex', gap: 1, alignItems: 'flex-start' }}>
              <span>⚠️</span>
              Are you sure you want to remove {removeUsers} seat{removeUsers > 1 ? 's' : ''}? The seat count on your active subscription will decrease immediately to {finalUsers} user{finalUsers > 1 ? 's' : ''}.
            </Typography>
          </Box>

          <Box sx={{ p: 1.75, borderRadius: '16px', bgcolor: 'background.neutral', border: '1px solid', borderColor: 'divider' }}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.82rem', mb: 1, color: 'error.main' }}>
              What happens after removal?
            </Typography>
            <Stack spacing={1}>
              <Stack direction="row" spacing={1} alignItems="flex-start">
                <Box sx={{ color: 'error.main', fontSize: '0.85rem' }}>•</Box>
                <Typography fontSize="0.76rem">The prorated value of the removed seats will be credited to your tenant wallet immediately.</Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="flex-start">
                <Box sx={{ color: 'error.main', fontSize: '0.85rem' }}>•</Box>
                <Typography fontSize="0.76rem">This will reduce your recurring subscription fee for future renewals.</Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="flex-start">
                <Box sx={{ color: 'error.main', fontSize: '0.85rem' }}>•</Box>
                <Typography fontSize="0.76rem">Please make sure that your active users do not exceed the new limit to avoid workspace blockage.</Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="flex-start">
                <Box sx={{ color: 'error.main', fontSize: '0.85rem' }}>•</Box>
                <Typography fontSize="0.76rem">This action cannot be undone.</Typography>
              </Stack>
            </Stack>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
          <Button variant="outlined" color="inherit" size="small" onClick={() => setRemoveConfirmOpen(false)} sx={{ borderRadius: '12px', px: 2.5 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            size="small"
            disableElevation
            onClick={() => { setRemoveConfirmOpen(false); proceedUpgrade(); }}
            sx={{ borderRadius: '12px', px: 2.5, fontWeight: 700 }}
          >
            Confirm & Remove
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={paymentVerifying}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          elevation: 0,
          sx: {
            borderRadius: 4,
            p: 4,
            width: "100%",
            maxWidth: 420,
            textAlign: "center",
            overflow: "hidden",
            boxShadow: "0 24px 60px rgba(15,23,42,0.12)",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          {/* Animated Loader */}
          <Box
            sx={{
              width: 92,
              height: 92,
              borderRadius: "50%",
              bgcolor: 'primary.lighter',
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <CircularProgress
              size={56}
              thickness={4}
              sx={{
                color: 'primary.main',
              }}
            />
          </Box>

          {/* Title */}
          <Typography
            variant="h5"
            fontWeight={700}
            color="text.primary"
          >
            {verifyMessages[verifyStep].title}
          </Typography>

          {/* Subtitle */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mt: 1.5,
              maxWidth: 300,
              lineHeight: 1.7,
            }}
          >
            {verifyMessages[verifyStep].subtitle}
          </Typography>

          {/* Progress Bar */}
          <LinearProgress
            sx={{
              width: "100%",
              mt: 4,
              height: 6,
              borderRadius: 10,
              bgcolor: "action.hover",
              "& .MuiLinearProgress-bar": {
                borderRadius: 10,
                bgcolor: 'primary.main',
              },
            }}
          />

          {/* Status */}
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mt: 2 }}
          >
            Please don't close this window while your payment is being verified.
          </Typography>
        </Box>
      </Dialog>

      <PaymentSuccessPopup
        open={successOpen}
        billingCycle={actualBillingCycle}
        onClose={() => { setSuccessOpen(false); setPaymentDetails(null); onClose(); }}
        plan={plan}
        paymentDetails={paymentDetails}
        currency={currency}
      />
    </>
  );
}

// ─── UNCHANGED: ModalShell, ModalHeader, ModalFooter ───────────────────────
function ModalShell({ open, onClose, children }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth scroll="paper"
      TransitionComponent={Fade} TransitionProps={{ timeout: 260 }}
      PaperProps={{ elevation: 0, sx: { borderRadius: { xs: '18px', sm: '22px' }, overflow: 'hidden', border: '0.5px solid', borderColor: 'divider', m: { xs: 1, sm: 2, md: 3 }, maxHeight: { xs: '95vh', sm: '92vh' }, boxShadow: '0 0 0 1px rgba(0,0,0,0.04), 0 8px 16px rgba(0,0,0,0.06), 0 32px 64px rgba(0,0,0,0.09)', bgcolor: 'background.default', display: 'flex', flexDirection: 'column' } }}
      slotProps={{ backdrop: { sx: { backdropFilter: 'blur(10px)', bgcolor: 'rgba(0,0,0,0.35)' } } }}
    >
      {children}
    </Dialog>
  );
}

function ModalHeader({ plan, title, subtitle, onClose }) {
  return (
    <Box sx={{ px: { xs: 3, sm: 4 }, py: { xs: 2.5, sm: 3 }, borderBottom: '0.5px solid', borderColor: 'divider', bgcolor: 'background.paper', flexShrink: 0 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={2} alignItems="center" minWidth={0}>
          <Box sx={{ width: { xs: 40, sm: 44 }, height: { xs: 40, sm: 44 }, borderRadius: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'primary.lighter', color: 'primary.main', border: '1px solid', borderColor: 'divider', flexShrink: 0, fontSize: { xs: '1.1rem', sm: '1.2rem' } }}>
            {plan.icon}
          </Box>
          <Box minWidth={0}>
            <Typography sx={{ fontWeight: 700, fontSize: { xs: '0.95rem', sm: '1.05rem' }, letterSpacing: '-0.025em', lineHeight: 1.25, color: 'text.primary' }}>{title}</Typography>
            {subtitle && <Typography sx={{ fontSize: '0.76rem', color: 'text.secondary', mt: 0.3 }}>{subtitle}</Typography>}
          </Box>
        </Stack>
        <IconButton onClick={onClose} size="small" sx={{ ml: 1.5, width: 32, height: 32, borderRadius: '9px', color: 'text.secondary', '&:hover': { bgcolor: 'action.hover' } }}>
          <Close sx={{ fontSize: '0.95rem' }} />
        </IconButton>
      </Stack>
    </Box>
  );
}

function ModalFooter({ onClose, onPrimaryClick, primaryLabel, loading, primaryDisabled }) {
  return (
    <Box sx={{ px: { xs: 2.5, sm: 4 }, py: { xs: 2, sm: 2.5 }, borderTop: '0.5px solid', borderColor: 'divider', bgcolor: 'background.paper', flexShrink: 0 }}>
      <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={1.5} alignItems="stretch">
        <Button onClick={onClose} variant="soft" color='error' sx={{ borderRadius: '11px', px: 3, py: 1.2, fontWeight: 600, fontSize: '0.875rem', borderColor: 'divider', color: 'text.secondary', width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 100 }, flexShrink: 0, '&:hover': { borderColor: 'text.secondary', bgcolor: 'action.hover' } }}>
          Cancel
        </Button>
        <Button fullWidth variant="contained" color="primary" onClick={onPrimaryClick} disabled={!!primaryDisabled}
          endIcon={!loading && <ArrowForward sx={{ fontSize: '1rem !important' }} />} disableElevation
          sx={{ borderRadius: '11px', py: 1.3, fontWeight: 700, fontSize: '0.88rem', flex: { sm: 1 } }}>
          {loading ? 'Processing…' : primaryLabel}
        </Button>
      </Stack>
    </Box>
  );
}

// ─── UNCHANGED logic: ContactSalesModal ────────────────────────────────────
export function ContactSalesModal({ open, onClose, plan, onSubmit, loading }) {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', company: '', message: '' });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setFormData({ name: '', email: '', phone: '', company: '', message: '' });
      setErrors({});
    }
  }, [open]);

  const planName = plan?.name || 'Enterprise';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9+\-\s()]{7,15}$/;

    if (!formData.name.trim()) newErrors.name = 'Full name is required';

    if (!formData.email.trim()) {
      newErrors.email = 'Work email is required';
    } else if (!emailRegex.test(formData.email.trim())) {
      newErrors.email = 'Enter a valid email address';
    }

    if (formData.phone.trim() && !phoneRegex.test(formData.phone.trim())) {
      newErrors.phone = 'Enter a valid phone number';
    }

    if (!formData.company.trim()) newErrors.company = 'Company name is required';
    if (!formData.message.trim()) newErrors.message = ' Your requirements are required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const isValid = validate();
    if (!isValid) return;
    onSubmit(formData);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="paper" TransitionComponent={Fade}
      PaperProps={{ sx: { borderRadius: { xs: '16px', sm: '20px' }, overflow: 'hidden', border: '1px solid', borderColor: 'divider', m: { xs: 2, sm: 3 }, maxHeight: 'calc(100% - 32px)' } }}
      slotProps={{ backdrop: { sx: { backdropFilter: 'blur(8px)', bgcolor: 'rgba(0,0,0,0.45)' } } }}
    >
      <form onSubmit={handleFormSubmit} noValidate>
        <Box sx={{ bgcolor: 'background.neutral', px: { xs: 2, sm: 3 }, pt: { xs: 2.5, sm: 3 }, pb: 2, borderBottom: '0.5px solid', borderColor: 'divider' }}>
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
            <Box>
              <Typography variant="subtitle1" fontWeight={700} sx={{ lineHeight: 1.2 }}>Contact sales for {planName}</Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>Tell us about your needs and we'll craft a custom solution.</Typography>
            </Box>
            <IconButton size="small" onClick={onClose} sx={{ color: 'text.secondary', mt: -0.5, mr: -1 }}><Close fontSize="small" /></IconButton>
          </Stack>
        </Box>
        <DialogContent
          sx={{
            px: { xs: 2, sm: 3 }, py: { xs: 2, sm: 3 }, overflowY: 'auto',
            '& .MuiFormLabel-asterisk': { color: '#d32f2f' },
          }}
        >
          <Stack spacing={2.5}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth label="Full name" name="name" size="small"
                value={formData.name} onChange={handleChange}
                error={!!errors.name} helperText={errors.name}
                InputLabelProps={{ required: true }}
                InputProps={{ sx: { borderRadius: '10px' } }}
              />
              <TextField
                fullWidth label="Work email" name="email" type="email" size="small"
                value={formData.email} onChange={handleChange}
                error={!!errors.email} helperText={errors.email}
                InputLabelProps={{ required: true }}
                InputProps={{ sx: { borderRadius: '10px' } }}
              />
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth label="Phone number" name="phone" size="small"
                value={formData.phone} onChange={handleChange}
                error={!!errors.phone} helperText={errors.phone}
                InputProps={{ sx: { borderRadius: '10px' } }}
              />
              <TextField
                fullWidth label="Company name" name="company" size="small"
                value={formData.company} onChange={handleChange}
                error={!!errors.company} helperText={errors.company}
                InputLabelProps={{ required: true }}
                InputProps={{ sx: { borderRadius: '10px' } }}
              />
            </Stack>
            <TextField
              fullWidth label="Tell us about your requirements" name="message" multiline rows={4} size="small"
              value={formData.message} onChange={handleChange}
              error={!!errors.message} helperText={errors.message}
              InputLabelProps={{ required: true }}
              InputProps={{ sx: { borderRadius: '10px' } }}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: { xs: 2, sm: 3 }, pb: { xs: 2, sm: 3 }, pt: 1.5, gap: 1 }}>
          <Button
            onClick={onClose}
            variant="contained"
            color="error"
            disableElevation
            sx={{ borderRadius: '10px', fontWeight: 600, fontSize: '0.82rem', py: 1 }}
          >
            Cancel
          </Button>
          <Button
            type="submit" variant="contained" color="primary" disabled={loading}
            endIcon={!loading && <Send sx={{ fontSize: 16 }} />}
            sx={{ borderRadius: '10px', fontWeight: 700, fontSize: '0.85rem', py: 1, px: 3 }}
          >
            {loading ? 'Submitting…' : 'Send request'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

// ─── ContactSalesSuccessModal ──────────────────────────────────────────────
export function ContactSalesSuccessModal({ open, onClose, contactData }) {
  const email = contactData?.email;
  const company = contactData?.company;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      TransitionComponent={Fade}
      PaperProps={{
        sx: {
          borderRadius: { xs: '16px', sm: '22px' },
          overflow: 'hidden',
          border: '1px solid',
          borderColor: 'divider',
          m: { xs: 2, sm: 3 },
          p: { xs: 3, sm: 3.5 },
          textAlign: 'center',
          bgcolor: 'background.paper',
          boxShadow: '0 24px 64px rgba(0, 0, 0, 0.14)',
        },
      }}
      slotProps={{ backdrop: { sx: { backdropFilter: 'blur(8px)', bgcolor: 'rgba(0,0,0,0.45)' } } }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* Check Icon with Soft Glow */}
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            bgcolor: alpha('#10b981', 0.12),
            color: '#10b981',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
            border: '2px solid',
            borderColor: alpha('#10b981', 0.3),
          }}
        >
          <CheckCircleRounded sx={{ fontSize: 34 }} />
        </Box>

        {/* Title */}
        <Typography variant="h6" fontWeight={800} sx={{ letterSpacing: '-0.02em', color: 'text.primary', mb: 0.75 }}>
          Inquiry Submitted!
        </Typography>

        {/* Description */}
        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.8rem', lineHeight: 1.55, mb: 2.25 }}>
          Thank you for reaching out{company ? ` on behalf of ` : ''}
          {company && <strong>{company}</strong>}.
          Our enterprise sales team has received your custom requirements and will contact you at{' '}
          {email ? <strong>{email}</strong> : 'your email'} within <strong>24 business hours</strong>.
        </Typography>

        {/* Next Steps Box */}
        <Box
          sx={{
            width: '100%',
            p: 1.75,
            borderRadius: '12px',
            bgcolor: 'action.hover',
            border: '1px solid',
            borderColor: 'divider',
            textAlign: 'left',
            mb: 2.5,
          }}
        >
          <Typography sx={{ fontSize: '0.65rem', fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.04em', mb: 1 }}>
            What happens next?
          </Typography>
          <Stack spacing={0.65}>
            <Typography sx={{ fontSize: '0.72rem', color: 'text.primary', display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <span style={{ color: '#10b981', fontWeight: 700 }}>1.</span> Requirements analysis by solution specialist
            </Typography>
            <Typography sx={{ fontSize: '0.72rem', color: 'text.primary', display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <span style={{ color: '#10b981', fontWeight: 700 }}>2.</span> Custom pricing proposal & architecture demo
            </Typography>
            <Typography sx={{ fontSize: '0.72rem', color: 'text.primary', display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <span style={{ color: '#10b981', fontWeight: 700 }}>3.</span> Dedicated onboarding executive assigned
            </Typography>
          </Stack>
        </Box>

        {/* Action Button */}
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          fullWidth
          sx={{
            borderRadius: '10px',
            py: 1.05,
            fontWeight: 700,
            fontSize: '0.82rem',
            textTransform: 'none',
            boxShadow: '0 4px 14px rgba(25, 118, 210, 0.2)',
          }}
        >
          Got it, thank you
        </Button>
      </Box>
    </Dialog>
  );
}

// ─── UNCHANGED logic: FeatureModal ─────────────────────────────────────────
export function FeatureModal({ open, onClose, selectedPlanDetails }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper" TransitionComponent={Fade} TransitionProps={{ timeout: 240 }}
      PaperProps={{ elevation: 0, sx: { borderRadius: { xs: '16px', sm: '20px' }, maxHeight: '82vh', display: 'flex', flexDirection: 'column', border: '0.5px solid', borderColor: 'divider', m: { xs: 1, sm: 2, md: 3 }, bgcolor: 'background.default', overflow: 'hidden' } }}
      slotProps={{ backdrop: { sx: { backdropFilter: 'blur(10px)', bgcolor: 'rgba(0,0,0,0.35)' } } }}
    >
      {selectedPlanDetails && (
        <>
          <Box sx={{ px: { xs: 3, sm: 3.5 }, py: 2.5, borderBottom: '0.5px solid', borderColor: 'divider', bgcolor: 'background.paper', flexShrink: 0 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Stack direction="row" spacing={1.75} alignItems="center">
                <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: 'primary.lighter', color: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '0.5px solid', borderColor: 'divider', fontSize: '0.95rem', flexShrink: 0 }}>
                  {selectedPlanDetails.icon}
                </Box>
                <Box>
                  <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: 'text.primary', letterSpacing: '-0.025em' }}>{selectedPlanDetails.name} · Feature list</Typography>
                  <Typography sx={{ fontSize: '0.71rem', color: 'text.secondary', mt: 0.15 }}>Full breakdown of what's included</Typography>
                </Box>
              </Stack>
              <IconButton onClick={onClose} size="small" sx={{ width: 30, height: 30, borderRadius: '8px', color: 'text.secondary', '&:hover': { bgcolor: 'action.hover' } }}>
                <Close sx={{ fontSize: '0.9rem' }} />
              </IconButton>
            </Stack>
          </Box>
          <DialogContent sx={{ p: { xs: 2.5, sm: 3 }, bgcolor: 'background.default', flex: 1, overflowY: 'auto', '&::-webkit-scrollbar': { width: 5 }, '&::-webkit-scrollbar-thumb': { bgcolor: 'divider', borderRadius: 3 } }}>
            <Box sx={{ borderRadius: '14px', bgcolor: 'background.paper', border: '0.5px solid', borderColor: 'divider', overflow: 'hidden', mb: 2.5 }}>
              <Box sx={{ px: 2.5, py: 2, borderBottom: '0.5px solid', borderColor: 'divider', bgcolor: 'background.neutral' }}>
                <Stack direction="row" alignItems="center" spacing={1.25}>
                  <Box sx={{ width: 20, height: 20, borderRadius: '50%', bgcolor: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Check sx={{ fontSize: 12, color: '#fff' }} />
                  </Box>
                  <Typography sx={{ fontSize: '0.78rem', fontWeight: 700, color: 'primary.main', letterSpacing: '0.04em' }}>What's included</Typography>
                </Stack>
              </Box>
              <Box sx={{ px: 2.5, py: 2 }}>
                <Stack spacing={1.4}>
                  {selectedPlanDetails.includedFeatures.map((feature, i) => (
                    <Stack direction="row" spacing={1.5} alignItems="flex-start" key={i}>
                      <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: 'primary.lighter', border: '0.5px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: '2px' }}>
                        <Check sx={{ fontSize: 10, color: 'primary.main' }} />
                      </Box>
                      <Typography sx={{ fontSize: '0.82rem', fontWeight: 500, color: 'text.primary', lineHeight: 1.55 }}>{feature}</Typography>
                    </Stack>
                  ))}
                </Stack>
              </Box>
            </Box>
            {selectedPlanDetails.excludedFeatures?.length > 0 && (
              <Box sx={{ borderRadius: '14px', bgcolor: 'background.paper', border: '0.5px solid', borderColor: 'divider', overflow: 'hidden' }}>
                <Box sx={{ px: 2.5, py: 2, borderBottom: '0.5px solid', borderColor: 'divider', bgcolor: 'background.neutral' }}>
                  <Stack direction="row" alignItems="center" spacing={1.25}>
                    <Box sx={{ width: 20, height: 20, borderRadius: '50%', bgcolor: 'error.main', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Close sx={{ fontSize: 11, color: '#fff' }} />
                    </Box>
                    <Typography sx={{ fontSize: '0.78rem', fontWeight: 700, color: 'error.main', letterSpacing: '0.04em' }}>Not available in this plan</Typography>
                  </Stack>
                </Box>
                <Box sx={{ px: 2.5, py: 2 }}>
                  <Stack spacing={1.4}>
                    {selectedPlanDetails.excludedFeatures.map((feature, i) => (
                      <Stack direction="row" spacing={1.5} alignItems="flex-start" key={i}>
                        <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: 'error.lighter', border: '0.5px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: '2px' }}>
                          <Close sx={{ fontSize: 10, color: 'error.main' }} />
                        </Box>
                        <Typography sx={{ fontSize: '0.82rem', fontWeight: 400, color: 'text.secondary', lineHeight: 1.55 }}>{feature}</Typography>
                      </Stack>
                    ))}
                  </Stack>
                </Box>
              </Box>
            )}
          </DialogContent>
        </>
      )}
    </Dialog>
  );
}